import {useEffect} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '../../../../template/_metronic/helpers'
import {useForgotPasswordMutation} from '../../../../redux/api/services/auth'
import {useAuth} from '../core/AuthProvider'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../redux/store'
import {CustomErrorAlert} from '../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Formato de correo electrónico incorrecto')
    .min(3, 'Mínimo 3 símbolos')
    .max(50, 'Máximo 50 símbolos')
    .required('Correo electronico es requerido'),
})

export function ForgotPassword() {
  const [requestPassword, {isError, isLoading, isSuccess, error, reset}] =
    useForgotPasswordMutation()
  const {setEmail} = useAuth()
  const navigate = useNavigate()
  const infoState = useSelector((state: RootState) => state.info)

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values) => {
      requestPassword({info: infoState, requestContent: {email: values.email}})
    },
  })

  useEffect(() => {
    if (!isSuccess) return
    setEmail(formik.values.email)
    navigate('/auth/reset-password')
  }, [isSuccess])

  return (
    <form
      className='form w-100 py-10 py-lg-29'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='d-flex flex-column align-items-center mb-10 text-center'>
        <SVG src={toAbsoluteUrl('/media/soyfri-media/logo-planillas.svg')} className='mb-8' />
        <SVG src={toAbsoluteUrl('/media/soyfri-media/login-separator.svg')} className='mb-7' />
        <h1 className='text-primary-dark fs-2hx'>¿Olvidaste tu contraseña?</h1>
        <div className='text-gray-500 fw-semibold fs-3 px-5 w-md-400px'>
          Para recuperar tu contraseña te enviaremos un código a tu correo electronico
        </div>
      </div>

      <CustomErrorAlert show={isError} error={error} close={reset} />

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-semibold text-primary-dark fs-3'>Correo electrónico</label>
        <input
          type='email'
          placeholder='correo@ejemplo.com'
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-solid text-primary-dark border-0 fs-3',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='d-grid mb-lg-40'>
        <button
          type='submit'
          id='kt_password_reset_submit'
          className='btn btn-lg btn-primary rounded-pill'
        >
          <span className='indicator-label'>Siguiente</span>
          {isLoading && (
            <span className='indicator-progress'>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Form group */}
    </form>
  )
}
